import type { UiFeatureFlagNames } from "@/gql/graphql";
import { createContext } from "react";

type FeatureFlagProviderContext = {
  enabledFeatureFlags: UiFeatureFlagNames[];
  features: Partial<Record<UiFeatureFlagNames, boolean>>;
  canUseFeatureFlag: (flagName: UiFeatureFlagNames) => boolean;
  canUseFeatureFlagAsync: (flagName: UiFeatureFlagNames) => Promise<boolean>;
};

export const FeatureFlagContext = createContext<
  FeatureFlagProviderContext | undefined
>(undefined);

export type { FeatureFlagProviderContext };
